import { Storybook } from "@tento-ui/ui/storybook";
import { DshTurnPrompt } from "./prompt";

export class DshTurnPromptStoryBook extends Storybook.Default {
  title(): string {
    return "Turn dsh · prompt";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Short",
        render: () =>
          DshTurnPrompt.makeWith({
            text: "let's check that it's back working again",
          }),
      },
      {
        title: "The fixture's prompt — wraps, still narrower than the column",
        render: () =>
          DshTurnPrompt.makeWith({
            text: "the transcript files one lane's tool calls under another "
              + "lane's prompt on ::history — figure out why and fix it",
          }),
      },
      {
        title: "Long — the 525px ceiling, not the percentage",
        render: () =>
          DshTurnPrompt.makeWith({
            text:
              "i'd like to improve our tsh default shell ui such that we sticky the user's prompt to the tab of the shell (capped to 2 lines), using a long horizontal divider as separation",
          }),
      },
      {
        title: "Multi-line — newlines survive",
        render: () =>
          DshTurnPrompt.makeWith({
            text: "run these in order:\n  1. cargo fmt\n  2. cargo test -p tsh",
          }),
      },
      {
        title: "Unbroken token — wraps rather than overflowing",
        render: () =>
          DshTurnPrompt.makeWith({
            text:
              "/Users/james/workspace/tento/tento-node-registry/tento-spool.node/html/routes/index.root.ts",
          }),
      },
    ];
  }
}
